import { render, staticRenderFns } from "./OpportunitySummaryList.vue?vue&type=template&id=33d17972&scoped=true&"
import script from "./OpportunitySummaryList.vue?vue&type=script&lang=js&"
export * from "./OpportunitySummaryList.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitySummaryList.vue?vue&type=style&index=0&id=33d17972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d17972",
  null
  
)

export default component.exports